import { unplugin } from "./index.js";

export default unplugin.esbuild;
